import { GridStateFactory } from '@b2b/common/factories/gridState/types';
import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ACMEListResponse, ColumnDef, extractACMEPayload, TODO } from '@b2b/types/core';
import { CartFormsModalFilloutComponentModule } from '../../../../cart/components/cart-forms/modals/fillout/cart-forms-modals-fillout';
import { CartFormsService } from '../../../../cart/components/cart-forms/services/cart-forms.service';
import { FormsSummariesListItem } from '@b2b/types/forms';
import { isPseudoEventItem } from '../../../utils';
import {
  buildModalData,
  buildOrgOrderFormModel,
  buildUpdateItems,
  FormDisplayOptions,
  OrgOrderEventFormInput,
  OrgOrderEventInput,
  OrdersDetailFormsModel,
  deduplicateOrderFormsByDisplaySettings,
} from './orders-detail-forms.utils';
import { MembershipDetails } from '@b2b/types/membership';
import uiRouter, { $q, StateParams, StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';

import { v4 as uuidv4 } from 'uuid';

OrdersDetailFormsController.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$timeout',
  '$filter',
  'CalendarService',
  'CartFormsService',
  'ApiService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'PermissionsService',
  'OrderService',
  'UserPreferencesService',
];

function OrdersDetailFormsController(
  $scope: IScope & { ordersDetail: TODO; ordersDetailForms: TODO },
  $state: StateService,
  $stateParams: StateParams,
  $timeout: ITimeoutService,
  $filter: IFilterService,
  CalendarService: CalendarService,
  CartFormsService: CartFormsService,
  ApiService: ApiService,
  GridStateFactory: GridStateFactory,
  GridDefinitionFactory: TODO,
  PermissionsService: PermissionsService,
  OrderService: TODO,
  UserPreferencesService: TODO,
) {
  const parentCtrl = $scope.ordersDetail;

  const formDisplayOptions: FormDisplayOptions = {
    parseDate: (date) => CalendarService.parseDate(date),
    filterDate: (date, format) => CalendarService.toFormat(date, format),
  };
  const ctrl = {
    model: [] as OrdersDetailFormsModel[],
    membershipsData: {},
    searchQuery: '',
    isLoaded: false,
    viewId: '' as string | undefined,
    gridState: new GridStateFactory(),

    gridName: $state.current.name + '.grid0',
    gridDefinition: new GridDefinitionFactory(),
    optionsOverride: {
      data: 'ordersDetailForms.model',
      columnDefs: [
        {
          field: 'formCategoryType',
          displayName: 'Type',
          visible: true,
          cellTemplate: `
            <div class="ui-grid-cell-contents">
              <span class="text-capitalize">{{ row.entity.formCategoryType}}</span>
            </div>
          `,
        },
        {
          field: 'itemNameDisplay',
          displayName: 'Event Template Name',
          visible: true,
          onCellNavClick: (row, col) => {
            ctrl.optionsOverride.appScopeProvider.viewItem(row);
          },
          cellTemplate: `
            <div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()">
              <a data-ng-click="grid.appScope.viewItem(row)" data-ng-if="row.entity.itemType === 'Event' && row.entity.itemName" role="link">
                <span class="sr-only">View Event </span>{{ row.entity.itemNameDisplay }}<span class="sr-only"> Details</span>
              </a>
            </div>
          `,
        },
        {
          field: 'membershipId',
          displayName: 'Membership ID',
          visible: true,
          onCellNavClick: (row, col) => {
            ctrl.optionsOverride.appScopeProvider.viewItem(row);
          },
          cellTemplate: `
            <div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()">
              <a data-ng-click="grid.appScope.viewItem(row)" data-ng-if="row.entity.itemType !== 'Event'" role="link">
                <span class="sr-only">View Membership ID</span> {{ row.entity.membershipId }}<span class="sr-only"> Details</span>
              </a>
            </div>
          `,
        },
        {
          field: 'membershipLevel',
          displayName: 'Membership Level',
          visible: true,
        },
        {
          field: 'membershipOffering',
          displayName: 'Membership Offering',
          visible: false,
        },
        {
          field: 'membershipLifecycle',
          displayName: 'Membership Lifecycle',
          visible: false,
        },
        {
          field: 'formName',
          displayName: 'Form Name',
          visible: true,
        },
        {
          field: 'formNumber',
          displayName: 'Response Number',
          visible: true,
        },
      ] as ColumnDef[],
      appScopeProvider: {
        onDataGridPaginate: (newPage, pageSize, sortField, sortDirection) => {
          ctrl.onDataGridPaginate(newPage, pageSize, sortField, sortDirection);
        },
        onDataGridSortChange: (grid, columns, page) => {
          ctrl.onDataGridSortChange(grid, columns, page);
        },
        onGridDblClick: function (row) {
          ctrl.onGridDblClick(row);
        },
        viewItem: function (row) {
          ctrl.viewItem(row);
        },
        addResponse: function (row) {
          ctrl.addResponse(row);
        },
      },
    },

    init: function () {
      ctrl.viewId = $state.current.name;
      $scope.$emit('Application::contentTitleChange', {
        title: 'Order Forms Summary',
        buttonLeft: {
          label: 'Back',
          action: function () {
            window.history.go(-1);
          },
        },
        buttonRight: {
          label: 'Edit Order',
          permissions: ['ORDER_UPDATE'],
          action: function () {
            $state.go('application.orders.edit', { orderId: parentCtrl.model.orderId });
          },
          isDisabled: parentCtrl.isDisabled(),
        },
      });

      ctrl.gridDefinition.init(ctrl.gridName, ctrl.optionsOverride, ctrl.viewId, $state.current.data.enablePreferences);

      if (PermissionsService.check('FORM_RESPONSE_VIEW')) {
        ctrl.optionsOverride.columnDefs.unshift({
          field: 'View',
          headerName: 'View',
          width: 60,
          onCellNavClick: (row, col) => {
            ctrl.optionsOverride.appScopeProvider.onGridDblClick(row);
          },
          cellTemplate: `
            <div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()">
              <a data-ng-click="grid.appScope.onGridDblClick(row)" role="link" data-ng-if="row.entity.formResponseId">View<span class="sr-only"> Details</span></a>
            </div>
          `,
          enableHiding: false,
          enableSorting: false,
        });
      }

      if (PermissionsService.check('FORM_RESPONSE_CREATE') && PermissionsService.check('ORDER_UPDATE')) {
        ctrl.optionsOverride.columnDefs.push({
          field: 'Action',
          headerName: 'Action',
          width: 60,
          onCellNavClick: (row, col) => {
            ctrl.optionsOverride.appScopeProvider.addResponse(row);
          },
          cellTemplate: `
            <div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()">
              <a data-ng-click="grid.appScope.addResponse(row)" role="link">
                <span data-ng-if="!row.entity.formResponseId">Add<span class="sr-only"> Response</span></span>
                <span data-ng-if="row.entity.formResponseId">Edit<span class="sr-only"> Response</span></span>
              </a>
            </div>
          `,
          enableHiding: false,
          enableSorting: false,
        });
      }

      $scope.$on('DataGrid::UserPreferencesLoaded', ctrl.initData);
    },

    initData: function () {
      const props = ctrl.gridDefinition.getGridState();
      ctrl.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
      ctrl.getFormSummary();
    },

    /**
     * for organization orders we need to fetch the forms from a different endpoint
     * and compare the results between the two calls to see which forms have no response yet
     */
    fetchOrgOrderForms: function () {
      const q = $q.defer();

      const accountId = parentCtrl.model.accountId;
      const eventItems = (parentCtrl.model.eventItems || []).filter(
        (eventItem) => eventItem.eventId && !isPseudoEventItem(eventItem),
      );

      if (!!accountId && !!eventItems.length) {
        const orderId = Number($stateParams.orderId);
        const customerId = parentCtrl.model.customerId;

        const promises = eventItems.map((eventItem) => {
          return ApiService.event.detail(eventItem.eventId);
        });

        $q.all(promises)
          .then((responses) => {
            const orgOrderFormsPerEvent: OrdersDetailFormsModel[] = responses
              .filter((response) => response.data.payload.orderForms)
              .flatMap((response) => {
                const event = response.data.payload as OrgOrderEventInput;
                const orderForms = response.data.payload.orderForms as OrgOrderEventFormInput[];

                return orderForms
                  .filter(
                    (form) => form.formCategoryType !== undefined && (form as TODO).preferences?.insideSales !== 'none',
                  )
                  .map((form) => buildOrgOrderFormModel(event, form, orderId, customerId))
                  .map((form) => {
                    const displayStartDate = CalendarService.toFormat(
                      CalendarService.parseDate(event.startTime),
                      UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),
                    );

                    const displayStartTime = CalendarService.toFormat(
                      CalendarService.parseDate(event.startTime),
                      UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
                    );

                    form.itemNameDisplay = event.name + ' on ' + displayStartDate + ' to ' + displayStartTime;
                    return form;
                  });
              });

            const deduplicatedForms = deduplicateOrderFormsByDisplaySettings(orgOrderFormsPerEvent);

            const formsWithNoResponse: OrdersDetailFormsModel[] = deduplicatedForms.filter((orgForm) => {
              return !ctrl.model.some((form) => form.formId === orgForm.formId && form.itemId === orgForm.itemId);
            });

            ctrl.model = [...ctrl.model, ...formsWithNoResponse];
            q.resolve();
          })
          .catch(() => {
            q.reject();
          });
      } else {
        q.resolve();
      }

      return q.promise;
    },

    getFormSummary: function () {
      ApiService.orders.forms
        .list(angular.extend({ orderId: $stateParams.orderId }, ctrl.gridState.getGridState()))
        .then(ctrl.success.init)
        .catch(ctrl.error.init);
    },

    viewItem: function (row: { entity: TODO }) {
      switch (row.entity.formCategoryType) {
        case 'event': {
          $state.go('application.programsInstance', { id: row.entity.itemId });
          break;
        }

        case 'membership': {
          $state.go('application.membership.detail', { id: row.entity.membershipId });
          break;
        }

        case 'donation':
        case 'addon':
        default:
          break;
      }

      return;
    },

    onGridDblClick: function (item) {
      if (PermissionsService.check('FORM_RESPONSE_VIEW')) {
        $state.go('application.orders.detail.forms.detail', { responseId: item.entity.formResponseId });
      }
    },

    addResponse: function (row: { entity: OrdersDetailFormsModel }) {
      const form = row.entity;

      const openModal = (existingResponse?: TODO) => {
        CartFormsService.openFormFilloutModalWithData(buildModalData(form, formDisplayOptions, existingResponse))
          .result.then((response: TODO) => {
            ctrl.isLoaded = false;
            ctrl.gridDefinition.isLoaded = false;
            ApiService.orders.forms.orders.forms
              .update({
                orderId: $stateParams.orderId,
                items: buildUpdateItems(form, response, ctrl.model),
              })
              .finally(() => {
                ctrl.getFormSummary();
              });
          })
          .catch(() => {
            // modal dismissed — no action needed
          });
      };

      if (form.formResponseId) {
        ApiService.form.responses
          .detail({ id: form.formResponseId })
          .then((response) => openModal(response.data.payload));
      } else {
        openModal();
      }
    },

    onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
      ctrl.gridState.updateGridState(newPage, pageSize, sortField, sortDirection);
      ctrl.getFormSummary();
    },

    onDataGridSortChange(grid, columns, page) {
      const data = columns[0];

      if (data) {
        ctrl.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
        ctrl.getFormSummary();
      }
    },

    processList: function (list: FormsSummariesListItem[]): OrdersDetailFormsModel[] {
      return (
        list
          // Map the remaining forms to the OrdersDetailFormsModel,
          // which includes display properties for the UI
          .map((item): OrdersDetailFormsModel => {
            const model = item as OrdersDetailFormsModel;

            const eventItem = parentCtrl.model.eventItems?.find((eventItem) => eventItem.eventId === model.itemId);
            const eventName = eventItem?.eventName || model.itemName || '';
            const eventDateFormatted = eventItem?.eventDate
              ? CalendarService.toFormat(
                  CalendarService.parseDate(eventItem.eventDate),
                  UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),
                ) + (eventItem.startHour ? ` at ${eventItem.startHour}` : '')
              : '';

            switch (model.formCategoryType) {
              case 'membership':
                model.itemName = '';
                model.membershipLifecycle = ctrl.getMembershipLifecycle(model.itemType);

                if (model.membershipId) {
                  model.membershipLevel = ctrl.membershipsData[model.membershipId].membershipCategory;
                  model.membershipOffering = ctrl.membershipsData[model.membershipId].offeringName;
                  model.itemNameDisplay = `${model.membershipLevel} - ${model.membershipOffering}`;
                }
                break;
              case 'event':
                model.itemNameDisplay = `${eventName}${eventDateFormatted ? ` on ${eventDateFormatted}` : ''}`;
                break;
              case 'donation':
              case 'addon':
              default:
                break;
            }

            model.uuid = uuidv4();

            return model;
          })
      );
    },

    getMembershipLifecycle: function (itemType) {
      return OrderService.getItemType(itemType, true);
    },

    getMembershipData: function (list: FormsSummariesListItem[]) {
      const membershipsPromises = list
        .filter((item) => item.formCategoryType === 'membership' && item.membershipId)
        .map((item) => ApiService.membership.detail(item.membershipId));

      return Promise.all(membershipsPromises).then((responses) => {
        return responses.map(extractACMEPayload()).filter((item) => !!item);
      });
    },

    success: {
      init: function (response: { data: ACMEListResponse<FormsSummariesListItem> }) {
        const formsList = response.data.payload.list;

        ctrl
          .getMembershipData(formsList)
          .then((membershipsList: MembershipDetails[]) => {
            if (membershipsList && membershipsList.length) {
              membershipsList.forEach((membership: MembershipDetails) => {
                ctrl.membershipsData[membership.id] = {
                  ...membership,
                };
              });
            }
          })
          .finally(() => {
            ctrl.model = ctrl.processList(formsList);
            ctrl.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
            ctrl.isLoaded = true;

            ctrl.fetchOrgOrderForms().then(() => {
              ctrl.gridDefinition.isLoaded = true;
              $timeout(() => {
                $scope.$broadcast('DataGrid::ResizeGrid', {
                  name: ctrl.gridDefinition.options.gridName,
                  datasetLength: ctrl.model.length,
                  totalItems: response.data.payload.pagination.count || ctrl.model.length,
                });
              }, 10);
            });
          });
      },
    },

    error: {
      init: function (response) {
        console.log(response);
      },
    },
  };

  $scope.ordersDetailForms = ctrl;
  ctrl.init();
}

export const OrdersDetailFormsModule = angular
  .module('acme.view.application.orders.detail.forms.controllers', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.service.permissions',
    'acme.common.service.helpers',
    'acme.common.service.order',
    'acme.common.service.calendar',
    CartFormsModalFilloutComponentModule,
    'acme.common.service.userPreferences',
  ])
  .controller('OrdersDetailFormsController', OrdersDetailFormsController).name;
